export default __webpack_public_path__ + "static/media/4.ffa26f9f.JPG";